import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional class names with last-wins Tailwind conflict resolution.
 *
 * `tailwind-merge` is configured by convention rather than configuration: the
 * type scale in tailwind.config.ts uses t-shirt names precisely so twMerge
 * recognises `text-lg` as a font-size and `text-accent` as a colour, and keeps
 * both. Numeric size names (`text-11`) would be misread as colours and one of
 * the two would be dropped — see the comment on `theme.fontSize`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
